/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginResponseDTO
 */
export interface LoginResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof LoginResponseDTO
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginResponseDTO
     */
    token?: string | null;
}

/**
 * Check if a given object implements the LoginResponseDTO interface.
 */
export function instanceOfLoginResponseDTO(value: object): value is LoginResponseDTO {
    return true;
}

export function LoginResponseDTOFromJSON(json: any): LoginResponseDTO {
    return LoginResponseDTOFromJSONTyped(json, false);
}

export function LoginResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'token': json['token'] == null ? undefined : json['token'],
    };
}

  export function LoginResponseDTOToJSON(json: any): LoginResponseDTO {
      return LoginResponseDTOToJSONTyped(json, false);
  }

  export function LoginResponseDTOToJSONTyped(value?: LoginResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'token': value['token'],
    };
}

